import { render, staticRenderFns } from "./suitch-soilv1.vue?vue&type=template&id=43f29cd3&scoped=true&"
import script from "./suitch-soilv1.vue?vue&type=script&lang=js&"
export * from "./suitch-soilv1.vue?vue&type=script&lang=js&"
import style0 from "./suitch-soilv1.vue?vue&type=style&index=0&id=43f29cd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f29cd3",
  null
  
)

export default component.exports